<template>
  <div>
    <div class="btn btn-xs btn-outline" @click="clickOpenSelectModal">
      <div
        class="flex flex-1 max-w-20 line-clamp-1 whitespace-nowrap items-center gap-2"
      >
        <template v-if="otherMateId">
          <span class="flex-1 line-clamp-1 whitespace-nowrap">
            {{ friendMateMap.get(otherMateId)?.name ?? otherMateName }}
          </span>

          <i
            class="iconify mingcute--close-circle-line w-4 flex-shrink-0"
            @click.self.stop="emit('update:other-mate-id', undefined)"
          ></i>
        </template>
        <template v-else>
          全部 OC
          <i class="iconify mingcute--triangle-fill rotate-180 w-2.5"></i>
        </template>
      </div>
    </div>

    <ModalFriendMateSelect
      v-model:show="showOcSelector"
      :sender="
        props.activeMateId
          ? mateStore.getMyMateById(props.activeMateId)
          : mateStore.userMate
      "
      @select="onSelect"
    />
    <!-- <VanPopup v-model:show="showOcSelector" position="bottom" class="h-[80%]">
      <div class="flex justify-center items-center h-full" v-if="loading">
        <div class="loading loading-ring loading-lg"></div>
      </div>
      <div v-else class="h-full overflow-hidden flex flex-col">
        <div class="flex justify-end items-center gap-2 pr-4 pt-4">
          <button
            class="btn btn-sm btn-outline"
            @click="showOcSelector = false"
          >
            取消
          </button>

          <button class="btn btn-sm btn-primary" @click="onConfirmOc">
            确定
          </button>
        </div>
        <van-checkbox-group
          v-model="tmpMateIdzz"
          shape="square"
          class="gap-2 flex flex-col p-4 flex-1 overflow-auto"
        >
          <van-checkbox
            v-for="mate in friendMateList"
            :key="mate.id"
            :name="mate.id"
            class="flex-shrink-0"
          >
            {{ mate.name }}
          </van-checkbox>
        </van-checkbox-group>
      </div>
    </VanPopup> -->
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import { useMate } from "@/stores/mate";
import { Mate } from "@/types/entity";
import { ApiGetMateRelationshipPage } from "@/apis/interaction";

const props = defineProps<{
  activeMateId?: number;
  otherMateId?: number;
  otherMateName?: string;
}>();

const emit = defineEmits<{
  (event: "confirm", value?: number): void;
  (event: "update:other-mate-id", value?: number): void;
}>();

watch(
  () => props.otherMateId,
  async (id) => {
    if (id && !friendMateMap.value.has(id)) {
      await fetchFriendMate();
      if (!friendMateMap.value.has(id)) {
        emit("update:other-mate-id", undefined);
      }
    }
  }
);

const showOcSelector = ref(false);

const mateStore = useMate();
const loading = ref(true);
const friendMateList = ref<Mate[]>([]);
const friendMateMap = ref<Map<number, Mate>>(new Map());

const clickOpenSelectModal = async () => {
  showOcSelector.value = true;
  loading.value = true;
  await fetchFriendMate();
  loading.value = false;
};

const fetchFriendMate = async () => {
  const res = await ApiGetMateRelationshipPage({
    pagination: {
      page: 1,
      perPage: 999,
    },
    filter: {
      targetType: "others",
      sourceMateId: props.activeMateId,
    },
    sort: {
      field: "dtUpdate",
      order: "desc",
    },
  });
  friendMateList.value = [];
  friendMateMap.value = new Map();

  for (const { targetMate } of res.page.data) {
    if (targetMate) {
      mateStore.friendMateMap.set(targetMate.id, targetMate);
      if (!friendMateMap.value.has(targetMate.id)) {
        friendMateList.value.push(targetMate);
        friendMateMap.value.set(targetMate.id, targetMate);
      }
    }
  }
};

const onSelect = (mate: Mate) => {
  showOcSelector.value = false;
  emit("update:other-mate-id", mate.id);
};
</script>
